import type { VatRateFigures } from '../types/dealerFundStatementPeriod.types';
import type { FundAccountPosting } from '../types/fundAccountPostings.types';

export interface PostingDisplayRow {
    id: string;
    posting: FundAccountPosting;
    leg: VatRateFigures | null;
}

const rowsFor = (posting: FundAccountPosting, index: number, split: boolean): PostingDisplayRow[] => {
    if (!split) return [{ id: `${index}`, posting, leg: null }];
    if (posting.splitState === 'unsplit') return [{ id: `${index}-unsplit`, posting, leg: null }];
    return posting.legs.map((leg, legIndex) => ({ id: `${index}-${legIndex}`, posting, leg }));
};

export const postingDisplayRows = (rows: FundAccountPosting[], split: boolean): PostingDisplayRow[] =>
    rows.flatMap((posting, index) => rowsFor(posting, index, split));
